import { render, staticRenderFns } from "./GoodsGroupPreview.vue?vue&type=template&id=bda37340&scoped=true&"
import script from "./GoodsGroupPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsGroupPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsGroupPreview.vue?vue&type=style&index=0&id=bda37340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda37340",
  null
  
)

export default component.exports